import { DEFAULT_CHAIN_ID, chains, routes } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import * as library from "viem/chains";

export * from "./contracts";

/** Bump this variable when cookies (or similar systems) require an update */
export const UNIQUE_CLIENT_SYSTEM_ID = 1;

export const FEATURE_FLASH_LOANS_ENABLED = false;
export const FEATURE_EMPTY_PROXY_ENABLED = false;

/** Infura dropped base support and wagmi's fallback */
const library_base_override = (() => {
  const chain = _.clone(library.base);
  return {
    ...chain,
    rpcUrls: {
      ...chain.rpcUrls,
      infura: undefined,
    },
  } as unknown as library.Chain;
})();

const library_polygon_override = (() => {
  const chain = _.clone(library.polygon);
  return {
    ...chain,
    rpcUrls: {
      ...chain.rpcUrls,
      infura: undefined,
    },
  } as unknown as library.Chain;
})();
/** The first supported chain will be the default one */
export const supported = [
  {
    id: chains.mainnet.chainId,
    local: chains.mainnet,
    wagmi: library.mainnet,
  },
  {
    id: chains.arbitrum.chainId,
    local: chains.arbitrum,
    wagmi: library.arbitrum,
  },
  {
    id: chains.avalanche.chainId,
    local: chains.avalanche,
    wagmi: library.avalanche,
  },
  {
    id: chains.base.chainId,
    local: chains.base,
    wagmi: library_base_override,
  },
  {
    id: chains.bsc.chainId,
    local: chains.bsc,
    wagmi: library.bsc,
  },
  {
    id: chains.gnosis.chainId,
    local: chains.gnosis,
    wagmi: library.gnosis,
  },
  {
    id: chains.optimism.chainId,
    local: chains.optimism,
    wagmi: library.optimism,
  },
  {
    id: chains.polygon.chainId,
    local: chains.polygon,
    wagmi: library_polygon_override,
  },
  {
    id: chains.scroll.chainId,
    local: chains.scroll,
    wagmi: library.scroll,
  },
  {
    id: chains.goerli.chainId,
    local: chains.goerli,
    wagmi: library.goerli,
  },
].sort((a, b) =>
  a.id === DEFAULT_CHAIN_ID ? -1 : b.id === DEFAULT_CHAIN_ID ? 1 : 0,
);
/* ------------------------------------------------ */

export const api = routes.client.api;
export const tabs = routes.client.tabs;
export const pages = routes.client.pages;

export const covers = {
  renounce: "renounce",
  cancel: "cancel",
  cancelMultiple: "cancelMultiple",
  transfer: "transfer",
  withdraw: "withdraw",
  withdrawMultiple: "withdrawMultiple",
};

export const modals = {
  account: "account",
  approval: "approval",
  autofillCreate: "autofillCreate",
  chainSelector: "chainSelector",
  chainSwitcher: "chainSwitcher",
  permissions: "permissions",
  details: "details",
  durationPicker: "durationPicker",
  expected: "expected",
  history: "history",
  legend: "legend",
  momentPicker: "momentPicker",
  options: "options",
  search: "search",
  share: "share",
  simulator: "simulator",
  tokenPicker: "tokenPicker",
  transaction: "transaction",
  proxy: "proxy",
  proxyInfo: "proxyInfo",
  sanctionAccount: "sanctionAccount",
  sanctionStream: "sanctionStream",
};

export const PERSIST_ID = {
  session: "session",
  expected: "expected",
  localTokens: "localTokens",
  permissions: `permissions-${UNIQUE_CLIENT_SYSTEM_ID}`,
};

export const PERMISSION_ID = {
  crisp: "crisp",
  mixpanel: "mixpanel",
  sentry: "sentry",
  vercel: "vercel",
};
